<template>
	<div>
		<!-- 外观 -->
		<div class="wjappearance">
			<!-- 左侧盒子  -->
			<div class="wjAppearance_left">
				<!-- 主颜色 -->
				<!-- <div class="wjColor_box">
					<div class="wjColor_children" v-for="(item, index) in resultBody" :key="index">
						<div v-if="index == 0">
							<p style="font-size: 16px; color: #333">{{ item.appearanceName }}</p>
							<div class="color_btn_box" v-if="tabPosition != 'phone'">
								<button
									v-for="(childItem, childIndex) in item.questionnaireAppearanceList"
									:key="childIndex"
									:style="{ backgroundColor: childItem.appearanceName }"
									@click="btnColor(childIndex, childItem)"
								>
									<i class="el-icon-check" v-show="childItem.appearanceName == style.subjectColor"></i>
								</button>
							</div>

							<div class="color_btn_box" v-if="tabPosition == 'phone'">
								<button
									v-for="(childItem, childIndex) in item.questionnaireAppearanceList"
									:key="childIndex"
									:style="{ backgroundColor: childItem.appearanceName }"
									@click="btnColorPhone(childIndex, childItem)"
								>
									<i class="el-icon-check" v-show="childItem.appearanceName == stylePhone.subjectColor"></i>
								</button>
							</div>
						</div>
					</div>
				</div> -->
				<!-- 动态默认分类 -->
				<div style="margin-top: 10px" v-if="tabPosition != 'phone'">
					<div v-for="(item, index) in resultBody" :key="index">
						<div v-if="index != 0" class="drop-down-display">
							<el-collapse v-model="activeName" accordion>
								<el-collapse-item :title="item.appearanceName" :name="index">
									<div style="width: 278px" v-for="(childItem, childIndex) in item.questionnaireAppearanceList" :key="childIndex">
										<img :src="childItem.appearanceUrl" alt="" class="classified_pictures" @click="imgSet(childItem.appearanceUrl)" />
									</div>
								</el-collapse-item>
							</el-collapse>
						</div>
					</div>
				</div>

				<div style="margin-top: 10px" v-if="tabPosition == 'phone'">
					<div v-for="(item, index) in resultBody" :key="index">
						<div v-if="index != 0" class="drop-down-display">
							<el-collapse v-model="activeName" accordion>
								<el-collapse-item :title="item.appearanceName" :name="index">
									<div style="width: 278px" v-for="(childItem, childIndex) in item.questionnaireAppearanceList" :key="childIndex">
										<img :src="childItem.appearanceUrl" alt="" class="classified_pictures" @click="imgSet(childItem.appearanceUrl)" />
									</div>
								</el-collapse-item>
							</el-collapse>
						</div>
					</div>
				</div>
			</div>

			<div class="wjAppearance_center">
				<div class="tab">
					<el-radio-group v-model="tabPosition" @change="tabChange">
						<el-radio-button label="phone">
							<i class="el-icon-mobile-phone"></i>
							手机
						</el-radio-button>
						<el-radio-button label="computer">
							<i class="el-icon-monitor"></i>
							电脑
						</el-radio-button>
					</el-radio-group>
				</div>
				<div class="phoneBox flex justify-content" v-if="tabPosition == 'phone'">
					<div class="phone-bj">
						<div class="phone-bj-box">
                            <AppearanceTM  v-if="gainData" :bandingstyle="stylePhone" :data="data" @submit="submit"></AppearanceTM>
						</div>
					</div>
					<div class="phone-bj-img"></div>
				</div>
				<!-- <div > -->
					<el-row :gutter="20" class="computerBox" v-if="tabPosition == 'computer'">
						<!-- <el-col :span="4"><div class="grid-content bg-purple" style="opacity: 0;">1</div></el-col> -->
						<el-col :span="24" class="content_center">
							<div 
								class="computer-bj" 
							>
								<AppearancePC :bandingstyle="style" v-if="gainData" :data="data" :path="path" @submit="submit"></AppearancePC>
							</div>
						</el-col>
					</el-row>
				<!-- </div> -->
			</div>

			<!-- 右侧盒子 -->
			<div class="wjAppearance_right">
				<div class="wjAppearance_right_children">
					<!-- 外观设置 -->
					<div class="setFirst">
						<span style="font-size: 16px; color: #333; margin-left: 10px">外观设置</span>
						<span style="margin-right: 10px">
							<el-radio-group v-model="tabPosition" @change="tabChange">
								<el-radio-button label="phone"><i class="el-icon-mobile-phone"></i></el-radio-button>
								<el-radio-button label="computer"><i class="el-icon-monitor"></i></el-radio-button>
							</el-radio-group>
						</span>
					</div>
					<!--电话-->
					<div v-if="tabPosition == 'phone'">
						<el-collapse accordion>
							<!-- 页眉 -->
							<el-collapse-item class="pad">
								<template slot="title">
									页眉
								</template>

								<div class="heiSeting">
									<span class="left">显示页眉</span>
									<span class="right">
										<el-switch
											v-model="stylePhone.appearancePhone.headerState"
											:active-value="1"
											:inactive-value="0"
											@change="setHeaderPhone(stylePhone.appearancePhone.headerState)"
										></el-switch>
									</span>
								</div>

								<div v-if="stylePhone.appearancePhone.headerState == 1">
									<div class="heiSeting">
										<span class="left">页眉类型</span>
										<div class="right tab_layout">
											<span
												:class="{
													activeCheck: stylePhone.appearancePhone.headerType == 0
												}"
												@click="setHTPhone(0)"
											>
												文字
											</span>
											<span
												:class="{
													activeCheck: stylePhone.appearancePhone.headerType == 1
												}"
												@click="setHTPhone(1)"
											>
												单图
											</span>
										</div>
									</div>
									<div v-if="stylePhone.appearancePhone.headerType == 0">
										<div class="heiSeting">
											<span class="left">文字内容</span>
											<span class="right">
												<el-input
													v-model="stylePhone.appearancePhone.headerContent"
													placeholder="请输入内容"
													@blur="setHeaderContentPhone(stylePhone.appearancePhone.headerContent)"
												></el-input>
											</span>
										</div>
										<div class="heiSeting">
											<div class="aaaaa">
												<span class="left">字体设置</span>
												<div
													class="right"
													style="
                            margin-left: 87px;
                            display: flex;
                            align-items: center;
                          "
												>
													<el-select v-model="stylePhone.appearancePhone.titleSize" placeholder="16" @change="setTitleSizePhone">
														<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
													</el-select>
													<el-color-picker v-model="stylePhone.appearancePhone.headerColor" @change="setheaderColorPhone"></el-color-picker>
													<span><img src="../../../public/img/cuti.png" alt="" @click="setHeaderBoldPhone" /></span>
													<span><img src="../../../public/img/xt.png" alt="" @click="setheaderItalicPhone" /></span>
													<span><img src="../../../public/img/xhx.png" alt="" @click="setheaderUnderlinePhone" /></span>
												</div>
											</div>
										</div>
										<div class="heiSeting">
											<span class="left">对齐方式</span>
											<div class="right tab_layout">
												<span
													:class="{
														activeCheck: stylePhone.appearancePhone.headerAlign == 'left'
													}"
													@click="headerAlignPhone('left')"
												>
													左对齐
												</span>
												<span
													:class="{
														activeCheck: stylePhone.appearancePhone.headerAlign == 'center'
													}"
													@click="headerAlignPhone('center')"
												>
													居中
												</span>
												<span
													:class="{
														activeCheck: stylePhone.appearancePhone.headerAlign == 'right'
													}"
													@click="headerAlignPhone('right')"
												>
													右对齐
												</span>
											</div>
										</div>
										<div class="heiSeting">
											<span class="left">背景颜色</span>
											<span class="right" style="margin-top: 10px; margin-right: 10px">
												<el-color-picker v-model="stylePhone.appearancePhone.headerBgcolor" size="mini" @change="setheaderBgcolorPhone"></el-color-picker>
											</span>
										</div>
									</div>
									<div v-if="stylePhone.appearancePhone.headerType == 1">
										<div v-if="stylePhone.appearancePhone.headerImg == ''">
											<div class="heiSeting">
												<span class="left">页眉图片</span>
												<span class="right">
													<el-upload
														class="avatar-uploader"
														:action="$config.service.uploadApi"
														:show-file-list="false"
														:on-success="handleSuccessPhone"
														:before-upload="beforeAvatarUpload"
														:data="QiniuData"
														:on-remove="handleRemove"
														multiple
														:limit="1"
													>
														<p style="font-size: 12px; color: #0080ff">添加图片</p>
													</el-upload>
												</span>
											</div>
										</div>
										<div v-if="stylePhone.appearancePhone.headerImg != ''">
											<div class="heiSeting">
												<span style="position: relative">
													<img
														:src="stylePhone.appearancePhone.headerImg"
														style="
                              width: 35px;
                              height: 23px;
                              position: absolute;
                              top: 16px;
                              left: 6px;
                            "
													/>
													<i class="el-icon-remove" @click="removeImgPhone" style="position: absolute; top: 17px; left: 20px"></i>
												</span>
											</div>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- 背景 -->
							<el-collapse-item class="pad">
								<template slot="title">
									背景
								</template>
								<div class="heiSeting">
									<span class="left">背景设置</span>
									<div class="right tab_layout">
										<span style="cursor: pointer;" :class="{ activeCheck: stylePhone.appearancePhone.bgState == 0 }" @click="setHTImgPhone(0)">上传图片</span>
										<span style="cursor: pointer;" :class="{ activeCheck: stylePhone.appearancePhone.bgState == 1 }" @click="setHTImgPhone(1)">选择颜色</span>
									</div>
								</div>
								<div v-if="stylePhone.appearancePhone.bgState == 0">
									<div class="heiSeting" v-if="stylePhone.appearancePhone.bgImg == ''">
										<span class="left">背景图片</span>
										<span class="right">
											<el-upload
												class="avatar-uploader"
												:action="$config.service.uploadApi"
												:show-file-list="false"
												:on-success="handleSuccess2Phone"
												:before-upload="beforeAvatarUpload2"
												:data="QiniuData2"
												:on-remove="handleRemove2"
												multiple
												:limit="1"
											>
												<p style="font-size: 12px; color: #0080ff">上传图片</p>
											</el-upload>
										</span>
									</div>
									<div class="heiSeting" v-if="stylePhone.appearancePhone.bgImg != ''">
										<span class="left">背景图片</span>
										<span class="right" style="position: relative">
											<img
												:src="stylePhone.appearancePhone.bgImg"
												style="
                          width: 35px;
                          height: 23px;
                          position: absolute;
                          top: 16px;
                          right: 18px;
                        "
											/>
											<i class="el-icon-remove" @click="removebgImgPhone" style="position: absolute; right: 5px; top: 10px"></i>
										</span>
									</div>
									<div class="heiSeting">
										<span class="left">背景位置</span>
										<div class="right tab_layout">
											<span
												:class="{
													activeCheck: stylePhone.appearancePhone.bgLocation == 'repeat'
												}"
												@click="setHTAddPhone(0)"
											>
												平铺
											</span>
											<span
												:class="{
													activeCheck: stylePhone.appearancePhone.bgLocation == 'no-repeat'
												}"
												@click="setHTAddPhone(1)"
											>
												居中
											</span>
										</div>
									</div>
									<!-- <div class="heiSeting">
										<span class="left">问卷底色</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="stylePhone.appearancePhone.bgQuestionnaire" size="mini" @change="setbgQuestionnairePhone"></el-color-picker>
										</span>
									</div> -->
									<div class="heiSeting">
										<span class="left">底色透明度</span>
										<div class="right block" style="width: 100px; margin-right: 20px">
											<el-slider v-model="stylePhone.appearancePhone.bgOpacity" @change="setbgOpacityPhone"></el-slider>
										</div>
									</div>
								</div>
								<div v-if="stylePhone.appearancePhone.bgState == 1">
									<div class="heiSeting">
										<span class="left">背景颜色</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="stylePhone.appearancePhone.bgColor" size="mini" @change="setbgColorPhone"></el-color-picker>
										</span>
									</div>
									<!-- <div class="heiSeting">
										<span class="left">问卷底色</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="stylePhone.appearancePhone.bgQuestionnaire" size="mini" @change="setbgQuestionnairePhone"></el-color-picker>
										</span>
									</div> -->

									<div class="heiSeting">
										<span class="left">底色透明度</span>
										<div class="right block" style="width: 100px; margin-right: -32px">
											<el-slider v-model="stylePhone.appearancePhone.bgOpacity" @change="setbgOpacityPhone"></el-slider>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- logo -->
							<el-collapse-item class="pad">
								<template slot="title">
									logo
								</template>
								<div class="heiSeting" v-if="stylePhone.appearancePhone.logoSet == ''">
									<span class="left">logo设置</span>
									<span class="right">
										<el-upload
											class="avatar-uploader"
                							:action="$config.service.uploadApi"
											:show-file-list="false"
											:on-success="handleSuccess3Phone"
											:before-upload="beforeAvatarUpload3"
											:data="QiniuData3"
											:on-remove="handleRemove3"
											multiple
											:limit="1"
										>
											<p style="font-size: 12px; color: #0080ff">上传图片</p>
										</el-upload>
									</span>
								</div>
								<div class="heiSeting" v-if="stylePhone.appearancePhone.logoSet != ''">
									<span class="left">logo设置</span>
									<span class="right" style="position: relative">
										<img
											:src="stylePhone.appearancePhone.logoSet"
											style="
                        width: 35px;
                        height: 23px;
                        position: absolute;
                        top: 16px;
                        right: 18px;
                      "
										/>
										<i class="el-icon-remove" @click="removelogoSetPhone" style="position: absolute; right: 5px; top: 10px"></i>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">logo位置</span>
									<div class="right tab_layout">
										<span
											:class="{
												activeCheck: stylePhone.appearancePhone.logoLocation == 'left'
											}"
											@click="setHTlogoLocationPhone('left')"
										>
											左对齐
										</span>
										<span
											:class="{
												activeCheck: stylePhone.appearancePhone.logoLocation == 'center'
											}"
											@click="setHTlogoLocationPhone('center')"
										>
											居中
										</span>
										<span
											:class="{
												activeCheck: stylePhone.appearancePhone.logoLocation == 'right'
											}"
											@click="setHTlogoLocationPhone('right')"
										>
											右对齐
										</span>
									</div>
								</div>
							</el-collapse-item>
							<!-- 字体设置 -->
							<el-collapse-item class="pad">
								<template slot="title">
									字体设置
								</template>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">项目标题</span>
										<div
											class="right"
											style="
												margin-left: 87px;
												display: flex;
												align-items: center;
											"
										>
											<el-select v-model="stylePhone.appearancePhone.fontTitleSize" placeholder="20" @change="setfontTitleSize">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="stylePhone.appearancePhone.fontTitleColor" @change="setfontTitleColorPhone"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setfontTitleBoldPhone" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setfontTitleItalicPhone" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setfontTitleUnderlinePhone" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">欢迎语</span>
										<div
											class="right"
											style="
												margin-left: 101px;
												display: flex;
												align-items: center;
											"
										>
											<el-select v-model="stylePhone.appearancePhone.fontWelcomeSize" placeholder="16" @change="setfontWelcomeSizePhone">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="stylePhone.appearancePhone.fontWelcomeColor" @change="setfontWelcomeColorPhone"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setfontWelcomeBoldPhone" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setfontWelcomeItalicPhone" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setfontWelcomeUnderlinePhone" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">题干</span>
										<div
											class="right"
											style="
												margin-left: 115px;
												display: flex;
												align-items: center;
											"
										>
											<el-select v-model="stylePhone.appearancePhone.fontStemSize" placeholder="16" @change="setfontStemSizePhone">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="stylePhone.appearancePhone.fontStemColor" @change="setfontStemColorPhone"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setfontStemBoldPhone" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setfontStemItalicPhone" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setfontStemUnderlinePhone" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">选项</span>
										<div
											class="right"
											style="
                        margin-left: 116px;
                        display: flex;
                        align-items: center;
                      "
										>
											<el-select v-model="stylePhone.appearancePhone.fontOptionSize" placeholder="14" @change="setfontOptionSizePhone">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="stylePhone.appearancePhone.fontOptionColor" @change="setfontOptionColorPhone"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setfontOptionBoldPhone" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setfontOptionItalicPhone" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setfontOptionUnderlinePhone" /></span>
										</div>
									</div>
								</div>
								<!-- <div class="heiSeting">
									<div class="aaaaa">
										<span class="left">结束语</span>
										<div
											class="right"
											style="
												margin-left: 103px;
												display: flex;
												align-items: center;
											"
										>
											<el-select v-model="style.appearance.titleSize" placeholder="12" @change="setTitleSizePhone">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="style.appearance.headerColor" @change="setheaderColor"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setHeaderBold" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setheaderItalic" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setheaderUnderline" /></span>
										</div>
									</div>
								</div> -->
							</el-collapse-item>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									按钮设置
								</template>
								<div class="heiSeting">
									<span class="left">提交按钮文字</span>
									<span class="right">
										<el-input
											v-model="buttonContentTM"
											placeholder="请输入内容"
											@blur="btnTextPhone()"
										></el-input>
									</span>
								</div>
							</el-collapse-item>
							<!-- 完成 -->
							<el-collapse-item class="pad">
								<template slot="title">
									显示设置
								</template>
								<div class="heiSeting">
									<span class="left">显示标题</span>
									<span class="right">
										<el-switch
											v-model="stylePhone.appearancePhone.displayTitle"
											:active-value="1"
											:inactive-value="0"
											@change="distitlePhone(stylePhone.appearancePhone.displayTitle)"
										></el-switch>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">显示欢迎语</span>
									<span class="right">
										<el-switch
											v-model="stylePhone.appearancePhone.displayWelcome"
											:active-value="1"
											:inactive-value="0"
											@change="diswelPhone(stylePhone.appearancePhone.displayWelcome)"
										></el-switch>
									</span>
								</div>
								<!-- <div class="heiSeting">
									<span class="left">显示题目序号</span>
									<span class="right">
										<el-switch
											v-model="stylePhone.appearancePhone.displayQuestionsno"
											:active-value="1"
											:inactive-value="0"
											@change="disQuestPhone(stylePhone.appearancePhone.displayQuestionsno)"
										></el-switch>
									</span>
								</div> -->
							</el-collapse-item>
						</el-collapse>
					</div>

					<!--电脑-->
					<div v-if="tabPosition == 'computer'">
						<el-collapse accordion>
                            <!-- 页眉 -->
							<el-collapse-item class="pad">
								<template slot="title">
									页眉
								</template>
								<div class="heiSeting">
									<span class="left">显示页眉</span>
									<span class="right">
										<el-switch
											v-model="style.appearance.headerState"
											:active-value="1"
											:inactive-value="0"
											@change="setHeader(style.appearance.headerState)"
										></el-switch>
									</span>
								</div>
								<div v-if="style.appearance.headerState == 1">
									<div class="heiSeting">
										<span class="left">页眉类型</span>
										<div class="right tab_layout">
											<span
												:class="{
													activeCheck: style.appearance.headerType == 0
												}"
												@click="setHT(0)"
											>
												文字
											</span>
											<span
												:class="{
													activeCheck: style.appearance.headerType == 1
												}"
												@click="setHT(1)"
											>
												单图
											</span>
										</div>
									</div>
									<div v-if="style.appearance.headerType == 0">
										<div class="heiSeting">
											<span class="left">文字内容</span>
											<span class="right">
												<el-input
													v-model="style.appearance.headerContent"
													placeholder="请输入内容"
													@blur="setHeaderContent(style.appearance.headerContent)"
												></el-input>
											</span>
										</div>
										<div class="heiSeting">
											<div class="aaaaa">
												<span class="left">字体设置</span>
												<div
													class="right"
													style="
                                                        margin-left: 87px;
                                                        display: flex;
                                                        align-items: center;
                                                    "
												>
													<!--页眉里的字体设置-->
													<el-select v-model="style.appearance.titleSize" placeholder="16" @change="setTitleSize">
														<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
													</el-select>
													<el-color-picker v-model="style.appearance.headerColor" @change="setheaderColor"></el-color-picker>
													<span><img src="../../../public/img/cuti.png" alt="" @click="setHeaderBold" /></span>
													<span><img src="../../../public/img/xt.png" alt="" @click="setheaderItalic" /></span>
													<span><img src="../../../public/img/xhx.png" alt="" @click="setheaderUnderline" /></span>
												</div>
											</div>
										</div>
										<div class="heiSeting">
											<span class="left">对齐方式</span>
											<div class="right tab_layout">
												<span
													:class="{
														activeCheck: style.appearance.headerAlign == 'left'
													}"
													@click="headerAlign('left')"
												>
													左对齐
												</span>
												<span
													:class="{
														activeCheck: style.appearance.headerAlign == 'center'
													}"
													@click="headerAlign('center')"
												>
													居中
												</span>
												<span
													:class="{
														activeCheck: style.appearance.headerAlign == 'right'
													}"
													@click="headerAlign('right')"
												>
													右对齐
												</span>
											</div>
										</div>
										<div class="heiSeting">
											<span class="left">背景颜色</span>
											<span class="right" style="margin-top: 10px; margin-right: 10px">
												<el-color-picker v-model="style.appearance.headerBgcolor" size="mini" @change="setheaderBgcolor"></el-color-picker>
											</span>
										</div>
									</div>
									<div v-if="style.appearance.headerType == 1">
										<div v-if="style.appearance.headerImg == ''">
											<div class="heiSeting">
												<span class="left">页眉图片</span>
												<span class="right">
													<el-upload
														class="avatar-uploader"
														:action="$config.service.uploadApi"
														:show-file-list="false"
														:on-success="handleSuccess"
														:before-upload="beforeAvatarUpload"
														:data="QiniuData"
														:on-remove="handleRemove"
														multiple
														:limit="1"
													>
														<p style="font-size: 12px; color: #0080ff">添加图片</p>
													</el-upload>
												</span>
											</div>
										</div>
										<!--页眉单图图片显示区 -->
										<div v-if="style.appearance.headerImg != ''">
											<div class="heiSeting">
												<span style="position: relative">
													<img
														:src="style.appearance.headerImg"
														style="
                                                            width: 35px;
                                                            height: 35px;
                                                            position: absolute;
                                                            top: 9px;
                                                            left: 6px;
                                                            "
													/>
													<i class="el-icon-remove" @click="removeImg" style="position: absolute; top: 1px; left: 20px"></i>
												</span>
											</div>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- 背景-->
							<el-collapse-item class="pad">
								<template slot="title">
									背景
								</template>
								<div class="heiSeting">
									<span class="left">背景设置</span>
									<div class="right tab_layout">
										<span :class="{ activeCheck: style.appearance.bgState == 0 }" @click="setHTImg(0)">上传图片</span>
										<span :class="{ activeCheck: style.appearance.bgState == 1 }" @click="setHTImg(1)">选择颜色</span>
									</div>
								</div>
								<div v-if="style.appearance.bgState == 0">
									<div class="heiSeting" v-if="style.appearance.bgImg == ''">
										<span class="left">背景图片</span>
										<span class="right">
											<!-- 电脑上传背景图片 -->
											<el-upload
												class="avatar-uploader"
												:action="$config.service.uploadApi"
												:show-file-list="false"
												:on-success="handleSuccess2"
												:before-upload="beforeAvatarUpload2"
												:data="QiniuData2"
												:on-remove="handleRemove2"
												multiple
												:limit="1"
											>
												<p style="font-size: 12px; color: #0080ff">上传图片</p>
											</el-upload>
										</span>
									</div>
									<div class="heiSeting" v-if="style.appearance.bgImg != ''">
										<span class="left">背景图片</span>
										<span class="right" style="position: relative">
											<img
												:src="style.appearance.bgImg"
												style="
                                                width: 35px;
                                                height: 23px;
                                                position: absolute;
                                                top: 16px;
                                                right: 18px;
                        "
											/>
											<i class="el-icon-remove" @click="removebgImg" style="position: absolute; right: 5px; top: 10px"></i>
										</span>
									</div>
									<div class="heiSeting">
										<span class="left">背景位置</span>
										<div class="right tab_layout">
											<span
												:class="{
													activeCheck: style.appearance.bgLocation == 'repeat'
												}"
												@click="setHTAdd(0)"
											>
												平铺
											</span>
											<span
												:class="{
													activeCheck: style.appearance.bgLocation == 'no-repeat'
												}"
												@click="setHTAdd(1)"
											>
												居中
											</span>
										</div>
									</div>
									<div class="heiSeting">
										<span class="left">底色透明度</span>
										<div class="right block" style="width: 100px; margin-right: 20px">
											<el-slider v-model="style.appearance.bgOpacity" @change="setbgOpacity"></el-slider>
										</div>
									</div>
								</div>
								<div v-if="style.appearance.bgState == 1">
									<div class="heiSeting">
										<span class="left">背景颜色</span>
										<span class="right" style="margin-top: 10px; margin-right: 10px">
											<el-color-picker v-model="style.appearance.bgColor" size="mini" @change="setbgColor"></el-color-picker>
										</span>
									</div>
									<div class="heiSeting">
										<span class="left">底色透明度</span>
										<div class="right block" style="width: 100px; margin-right:-32px">
											<el-slider v-model="style.appearance.bgOpacity" @change="setbgOpacity"></el-slider>
										</div>
									</div>
								</div>
							</el-collapse-item>
							<!-- logo -->
							<el-collapse-item class="pad">
								<template slot="title">
									logo
								</template>
								<div class="heiSeting" v-if="style.appearance.logoSet == ''">
									<span class="left">logo设置</span>
									<span class="right">
										<el-upload
											class="avatar-uploader"
											:action="$config.service.uploadApi"
											:show-file-list="false"
											:on-success="handleSuccess3"
											:before-upload="beforeAvatarUpload3"
											:data="QiniuData3"
											:on-remove="handleRemove3"
											multiple
											:limit="1"
										>
											<p style="font-size: 12px; color: #0080ff">上传图片</p>
										</el-upload>
									</span>
								</div>
								<div class="heiSeting" v-if="style.appearance.logoSet != ''">
									<span class="left">logo设置</span>
									<span class="right" style="position: relative">
										<!-- logo设置 -->
										<img
											:src="style.appearance.logoSet"
											style="
                        width: 35px;
                        height: 23px;
                        position: absolute;
                        top: 16px;
                        right: 18px;
                      "
										/>
										<i class="el-icon-remove" @click="removelogoSet" style="position: absolute; right: 5px; top: 10px"></i>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">logo位置</span>
									<div class="right tab_layout">
										<span
											:class="{
												activeCheck: style.appearance.logoLocation == 'left'
											}"
											@click="setHTlogoLocation('left')"
										>
											左对齐
										</span>
										<span
											:class="{
												activeCheck: style.appearance.logoLocation == 'center'
											}"
											@click="setHTlogoLocation('center')"
										>
											居中
										</span>
										<span
											:class="{
												activeCheck: style.appearance.logoLocation == 'right'
											}"
											@click="setHTlogoLocation('right')"
										>
											右对齐
										</span>
									</div>
								</div>
							</el-collapse-item>
                            <!-- 字体设置 -->
							<el-collapse-item class="pad">
								<template slot="title">
									字体设置
								</template>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">项目标题</span>
										<div
											class="right"
											style="
                                                margin-left: 87px;
                                                display: flex;
                                                align-items: center;
                                            "
										>
											<el-select v-model="style.appearance.fontTitleSize" placeholder="20" @change="setfontTitleSize">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="style.appearance.fontTitleColor" @change="setfontTitleColor"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setfontTitleBold" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setfontTitleItalic" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setfontTitleUnderline" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">欢迎语</span>
										<div
											class="right"
											style="
                                                margin-left: 101px;
                                                display: flex;
                                                align-items: center;
                                            "
										>
											<el-select v-model="style.appearance.fontWelcomeSize" placeholder="16" @change="setfontWelcomeSize">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="style.appearance.fontWelcomeColor" @change="setfontWelcomeColor"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setfontWelcomeBold" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setfontWelcomeItalic" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setfontWelcomeUnderline" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">题干</span>
										<div
											class="right"
											style="
                        margin-left: 115px;
                        display: flex;
                        align-items: center;
                      "
										>
											<el-select v-model="style.appearance.fontStemSize" placeholder="16" @change="setfontStemSize">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="style.appearance.fontStemColor" @change="setfontStemColor"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setfontStemBold" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setfontStemItalic" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setfontStemUnderline" /></span>
										</div>
									</div>
								</div>
								<div class="heiSeting">
									<div class="aaaaa">
										<span class="left">选项</span>
										<div
											class="right"
											style="
                                                margin-left: 116px;
                                                display: flex;
                                                align-items: center;
                                            "
										>
											<el-select v-model="style.appearance.fontOptionSize" placeholder="14" @change="setfontOptionSize">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="style.appearance.fontOptionColor" @change="setfontOptionColor"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setfontOptionBold" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setfontOptionItalic" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setfontOptionUnderline" /></span>
										</div>
									</div>
								</div>
								<!-- <div class="heiSeting">
									<div class="aaaaa">
										<span class="left">结束语</span>
										<div
											class="right"
											style="
                        margin-left: 103px;
                        display: flex;
                        align-items: center;
                      "
										>
											<el-select v-model="style.appearance.fontEndSize" placeholder="12" @change="setfontEndSize">
												<el-option v-for="item in options" :key="item.val" :label="item.val" :value="item.val"></el-option>
											</el-select>
											<el-color-picker v-model="style.appearance.fontEndColor" @change="setfontEndColor"></el-color-picker>
											<span><img src="../../../public/img/cuti.png" alt="" @click="setfontEndBold" /></span>
											<span><img src="../../../public/img/xt.png" alt="" @click="setfontEndItalic" /></span>
											<span><img src="../../../public/img/xhx.png" alt="" @click="setfontEndUnderline" /></span>
										</div>
									</div>
								</div> -->
							</el-collapse-item>
							<!-- 按钮设置 -->
							<el-collapse-item class="pad">
								<template slot="title">
									按钮设置
								</template>
								<div class="heiSeting">
									<span class="left">提交按钮文字</span>
									<span class="right">
										<el-input v-model="buttonContentPC" placeholder="请输入内容" @blur="btnText()"></el-input>
									</span>
								</div>
							</el-collapse-item>
							<!-- 显示设置 -->
							<el-collapse-item class="pad">
								<template slot="title">
									显示设置
								</template>
								<div class="heiSeting">
									<span class="left">显示标题</span>
									<span class="right">
										<el-switch
											v-model="style.appearance.displayTitle"
											:active-value="1"
											:inactive-value="0"
											@change="distitle(style.appearance.displayTitle)"
										></el-switch>
									</span>
								</div>
								<div class="heiSeting">
									<span class="left">显示欢迎语</span>
									<span class="right">
										<el-switch
											v-model="style.appearance.displayWelcome"
											:active-value="1"
											:inactive-value="0"
											@change="diswel(style.appearance.displayWelcome)"
										></el-switch>
									</span>
								</div>
								<!-- <div class="heiSeting">
									<span class="left">显示题目序号</span>
									<span class="right">
										<el-switch
											v-model="style.appearance.displayQuestionsno"
											:active-value="1"
											:inactive-value="0"
											@change="disQuest(style.appearance.displayQuestionsno)"
										></el-switch>
									</span>
								</div> -->
							</el-collapse-item>
						</el-collapse>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AppearancePC from './components/appearancePC.vue'
import AppearanceTM from './components/appearanceTM.vue'
import { v1 as UUID } from "uuid";
import { mapState } from "vuex";
export default {
	beforeRouteEnter(to, from, next){
		next((vm) =>{
			vm.path = to.path
		})
	},
    components:{
        AppearancePC,
        AppearanceTM
    },
	data() {
		return {
			id: '',
			path: '', // 当前组件的path
			bgindex: 0,
			childIndex: 0,
			yanse: '',
			// paperappurl: '',
			paperpcurl: '',
			tabPosition: 'phone',
			resultBody: [],
			activeName: '1',
			style: {
				subjectColor: '',
				appearance: {
                    headerType: 0,
                    headerBold: 'normal',
                    headerItalic: 'normal',
                    headerUnderline: 'none',
                    headerAlign: 'left',
                    headerImg: '',
                    bgState: 0,
                    bgImg: '',
                    headerBgcolor: '#EFF4FE',
                    bgLocation: 'repeat',
                    logoSet: '',
                    logoLocation: 'left',
                    fontTitleSize: '20',
                    fontTitleBold: 'bold',
                    fontTitleItalic: 'normal',
                    fontTitleUnderline: 'none',
                    fontWelcomeBold: 'normal',
                    fontWelcomeItalic: 'normal',
                    fontWelcomeUnderline: 'none',
                    fontStemBold: 'normal',
                    fontStemItalic: 'normal',
                    fontStemUnderline: 'none',
                    fontOptionBold: 'normal',
                    fontOptionItalic: 'normal',
                    fontOptionUnderline: 'none',
                    buttonContent: '提交',
                    displayTitle: 1,
                    displayWelcome: 1,
                    displayQuestionsno: 1,
					bgOpacity: 100, //背景透明度

                }
			},
            buttonContentPC: '提交',
            buttonContentTM: '提交',
			stylePhone: {
				subjectColor: '',
				appearancePhone: {
					buttonContent: '提交',
					submitButtonColor: '',
					logoSet: '', //logo
					headerImg: '', //页眉图片
					headerState: '', //页眉设置
					headerType: 0, //头部 文字图片切换
					headerContent: '', //头部内容
					titleSize: '', //标题大小
					headerColor: '', // 头部颜色
					headerBold: 'normal', //头部加粗
                    headerItalic: 'normal',
                    headerUnderline: 'none',
                    headerAlign: 'left',
					bgState: 0, //背景图片文字切换
					bgImg: '', //背景图片
					bgQuestionnaire: '', //问卷底色
					bgOpacity: 100, //背景透明度
					headerBgcolor: '#EFF4FE', //背景颜色
					bgColor: '#FFFFFF', //背景颜色
					fontTitleSize: '20',
					// 项目
					fontTitleBold: 'normal',
					fontTitleColor: '',
					fontTitleItalic: 'normal',
					fontTitleUnderline: 'none',
                    bgLocation: 'repeat',
                    logoLocation: 'left',
                    displayTitle: 1,
                    displayWelcome: 1,
                    displayQuestionsno: 1,
                    fontWelcomeBold: 'normal',
                    fontWelcomeItalic: 'normal',
                    fontWelcomeUnderline: 'none',
                    fontStemBold: 'normal',
                    fontStemItalic: 'normal',
                    fontStemUnderline: 'none',
                    fontOptionBold: 'normal',
                    fontOptionItalic: 'normal',
                    fontOptionUnderline: 'none',
				},
				da:{
					id: '',
					arr: [
						{
							id: '', // 试题id
							value: '', // 选项的id  多选是逗号分隔的字符串
							type: '',

						}
					]
				}
			},
			pageUrl: '',
			headerType: 0,
			options: [{ val: 14 }, { val: 16 }, { val: 18 }, { val: 20 }, { val: 22 }, { val: 28 }, { val: 36 }, { val: 48 }],
			QiniuData: {
				biz: 'upDataKs',
				data: {}
			},
			QiniuData2: {
				biz: 'upDataKs',
				data: {}
			},
			QiniuData3: {
				biz: 'upDataKs',
				data: {}
			},
			uploadPicUrl: '',
			fileList: [],
			data: {},
			gainData: false,
			styleId: ''
		};
	},
  	computed:{
		...mapState(['examQuestionTypeArr', 'headers']),
	},
	mounted() {
		// let that = this;
		// let bgindex = localStorage.getItem('bgindex');
		// that.loadAskTypeData()
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};

		//在mounted钩子函数绑定滚动条事件
		// document.getElementById("wenjuan_list").addEventListener('scroll', this.scroll);
		// that.wid = sessionStorage.getItem('wid') || 0;
		// // console.log('输出id', that.wid);
		// if (that.wid == 0) {
		// 	// this.wjadd();
		// } else {
		// 	// that.pageUrl = '/wjpc.html?id='+that.wid
		// 	sessionStorage.setItem('wid', that.wid);
		// }
		// this.loadAppear();
		this.loadStyle();
	},
	created() {
		if(sessionStorage.getItem("examId")){
			this.id = sessionStorage.getItem("examId")
			this.getData()
			// this.getJson()
			this.getStyleData()
		}
	},
	methods: {
		getStyleData() {
			let that = this
			let type = 0
			if (this.tabPosition == 'phone') {
				type = 0
			} else {
				type = 1
			}
			let data = {
				surveyId: this.id,
				type: type,
			}
			let params = {
				that: this,
				url: `${this.$config.service.examfindOneBySurveyId}`,
				method: "POST",
				data: data,
				cb(res) {
					if (!res) {
						that.add()
					} else {
						that.styleId = res.id
						if (type == 1) {
							// if (that.$functions.isJSON(res.contentjson)) {
								that.style.appearance = JSON.parse(res.contentjson)
							// }
						} else {
							that.stylePhone.appearancePhone = JSON.parse(res.contentjson)
						}
					}
				},
			};
			this.$util.request(params);
		},
		add() {
			
			let that = this
			let data = {
				surveyId: this.id,
				type: 1,
			}
			let dataPhone = {
				surveyId: this.id,
				type: 0,
			}
			let params = {
				that: this,
				url: `${this.$config.service.examAppearanceAdd}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						console.log('成功修改Pc', res) // pc
					}
				}
			};
			that.$util.request(params)
			let paramsPhone = {
				that: this,
				url: `${this.$config.service.examAppearanceAdd}`,
				method: 'POST',
				data: dataPhone,
				cb(res) {
					if (res.code == 0) {
						console.log('手机端成功修改', res, that.stylePhone.appearancePhone) //app
					}
				}
			};
			that.$util.request(paramsPhone)
		},
		getData() {
			console.log('获取试题')
			let that = this
			let params = {
				that: this,
				url: `${this.$config.service.examPaperpreview}?id=${this.id}`,
				method: "POST",
				cb(res) {
					let index = 0, arr = []
					console.log(res)
					that.gainData = true
					that.data = JSON.parse(res.resultBody.tbExamPaper.paperjson)
					that.data.questionsList.forEach((info) => {
						console.log(info.isHideTitle)
						if (info.isHideTitle == false){
							arr.push(info)
							if (that.examQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {
								info.quesIndex = index
								index++
							}
						}
					})
					that.data.questionsList = arr
					that.data.questionsList.forEach((info, index) =>{
						that.$set(info, 'validate', false)
						switch (info.questionsTypeId) {
							case 101: // 多选
								that.$set(info, 'userAnswerArr', [])
								that.$set(info, 'validateMsg', '请选择选项')
								break;
							case 100:
							case 102:
								that.$set(info, 'userAnswer', '')
								that.$set(info, 'validateMsg', '请选择一个选项')
								break;
							case 207: // 多项填空
							case 208: // 横向填空
								that.$set(info, 'userAnswer', 0)
								if (info.optionList.length > 0) {
									info.optionList.forEach((item, i) => {
										that.$set(item, 'userAnswer', '')
										that.$set(item, 'validate', false)
										that.$set(item, 'validateMsg', '请输入内容')
									})
								}
								break;
							default:
								that.$set(info, 'userAnswer', '')
								that.$set(info, 'validate', false)
								that.$set(info, 'validateMsg', '请输入内容')
						}
					})
				},
			};
			this.$util.request(params);
		},
		submit(){
            this.$notify({
                title: '提示',
                message: '当前为预览页面，答案不被记录。'
            });
            console.log('当前为预览页面，答案不被记录。')
        },
		getJson() {
			// console.log('获取试题')
			let that = this
			let params = {
				that: this,
				url: `${this.$config.service.examAppearanceFindById}?id=${this.id}`,
				method: "POST",
				cb(res) {
					console.log(res)
				},
			};
			this.$util.request(params);
		},
		setStyleApi(data) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examedit}`,
				method: 'POST',
				data: data,
				cb(res) {
					if (res.code == 0) {
						if (this.tabPosition != 'phone') { 
							console.log('成功修改Pc', res) // pc
						} else if (this.tabPosition == 'phone') { 
							console.log('手机端成功修改', res, that.stylePhone.appearancePhone) //app
						}
					}
				}
			};
			that.$util.request(params)
		},
		sendmessage() {
            // this.$message('设置成功')
			console.log(JSON.stringify(this.style.appearance))
			if (this.tabPosition != 'phone') {
				let data = {
					surveyId: this.id,
					type: 1,
					contentjson: JSON.stringify(this.style.appearance),
					// id: this.styleId
				}
				this.setStyleApi(data)
			} else if (this.tabPosition == 'phone') {
				//保存手机端
				let data = {
					surveyId: this.id,
					type: 0,
					contentjson: JSON.stringify(this.stylePhone.appearancePhone),
					// id: this.styleId
				}
				this.setStyleApi(data)
			}
		},
        // 页眉是否开启
        setHeader(id) {
			this.style.appearance.headerState = id;
			this.sendmessage();
		},
		setHT(val) {
			this.style.appearance.headerType = val;
			this.sendmessage();
		},
		setHeaderContent(item) {
			this.style.appearance.headerContent = item;
			this.sendmessage();
		},
        // 
		//结束语 下划线       ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓
		setfontEndUnderline() {
			if (this.style.appearance.fontEndUnderline == 'none') {
				this.style.appearance.fontEndUnderline = 'underline';
			} else if (this.style.appearance.fontEndUnderline == 'underline') {
				this.style.appearance.fontEndUnderline = 'none';
			}
			this.sendmessage();
		},
		//结束语  斜体
		setfontEndItalic() {
			if (this.style.appearance.fontEndItalic == 'normal') {
				this.style.appearance.fontEndItalic = 'italic';
			} else if (this.style.appearance.fontEndItalic == 'italic') {
				this.style.appearance.fontEndItalic = 'normal';
			}
			this.sendmessage();
		},
		//结束语  加粗
		setfontEndBold() {
			if (this.style.appearance.fontEndBold == 'normal') {
				this.style.appearance.fontEndBold = 'bold';
			} else if (this.style.appearance.fontEndBold == 'bold') {
				this.style.appearance.fontEndBold = 'normal';
			}
			this.sendmessage();
		},
		//结束语 字体颜色
		setfontEndColor(val) {
			this.style.appearance.fontEndColor = val;
			this.sendmessage();
		},
		//字体设置 结束语
		setfontEndSize(item) {
			// console.log('itme项目选项', item);
			this.style.appearance.fontEndSize = item;
			this.sendmessage();
		},
		//选项 字体下划线
		setfontOptionUnderline() {
			if (this.style.appearance.fontOptionUnderline == 'none') {
				this.style.appearance.fontOptionUnderline = 'underline';
			} else if (this.style.appearance.fontOptionUnderline == 'underline') {
				this.style.appearance.fontOptionUnderline = 'none';
			}
			this.sendmessage();
		},
		setfontOptionUnderlinePhone() {
			if (this.stylePhone.appearancePhone.fontOptionUnderline == 'none') {
				this.stylePhone.appearancePhone.fontOptionUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.fontOptionUnderline == 'underline') {
				this.stylePhone.appearancePhone.fontOptionUnderline = 'none';
			}
			this.sendmessage();
		},
		//选项 字体斜体
		setfontOptionItalic() {
			if (this.style.appearance.fontOptionItalic == 'normal') {
				this.style.appearance.fontOptionItalic = 'italic';
			} else if (this.style.appearance.fontOptionItalic == 'italic') {
				this.style.appearance.fontOptionItalic = 'normal';
			}
			this.sendmessage();
		},
		setfontOptionItalicPhone() {
			if (this.stylePhone.appearancePhone.fontOptionItalic == 'normal') {
				this.stylePhone.appearancePhone.fontOptionItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.fontOptionItalic == 'italic') {
				this.stylePhone.appearancePhone.fontOptionItalic = 'normal';
			}
			this.sendmessage();
		},
		//选项 字体加粗
		setfontOptionBold() {
			if (this.style.appearance.fontOptionBold == 'normal') {
				this.style.appearance.fontOptionBold = 'bold';
			} else if (this.style.appearance.fontOptionBold == 'bold') {
				this.style.appearance.fontOptionBold = 'normal';
			}
			this.sendmessage();
		},
		setfontOptionBoldPhone() {
			if (this.stylePhone.appearancePhone.fontOptionBold == 'normal') {
				this.stylePhone.appearancePhone.fontOptionBold = 'bold';
			} else if (this.stylePhone.appearancePhone.fontOptionBold == 'bold') {
				this.stylePhone.appearancePhone.fontOptionBold = 'normal';
			}
			this.sendmessage();
		},
		//选项 字体颜色
		setfontOptionColor(val) {
			this.style.appearance.fontOptionColor = val;
			this.sendmessage();
		},
		setfontOptionColorPhone(val) {
			this.stylePhone.appearancePhone.fontOptionColor = val;
			this.sendmessage();
		},
		//字体设置 选项
		setfontOptionSize(item) {
			// console.log('itme项目选项', item);
			this.style.appearance.fontOptionSize = item;
			this.sendmessage();
		},
		setfontOptionSizePhone(item) {
			// console.log('itme项目选项', item);
			this.stylePhone.appearancePhone.fontOptionSize = item;
			this.sendmessage();
		},
		//设置字体下划线
		setfontStemUnderline() {
			if (this.style.appearance.fontStemUnderline == 'none') {
				this.style.appearance.fontStemUnderline = 'underline';
			} else if (this.style.appearance.fontStemUnderline == 'underline') {
				this.style.appearance.fontStemUnderline = 'none';
			}
			this.sendmessage();
		},
		setfontStemUnderlinePhone() {
			if (this.stylePhone.appearancePhone.fontStemUnderline == 'none') {
				this.stylePhone.appearancePhone.fontStemUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.fontStemUnderline == 'underline') {
				this.stylePhone.appearancePhone.fontStemUnderline = 'none';
			}
			this.sendmessage();
		},
		//题干 斜线
		setfontStemItalic() {
			if (this.style.appearance.fontStemItalic == 'normal') {
				this.style.appearance.fontStemItalic = 'italic';
			} else if (this.style.appearance.fontStemItalic == 'italic') {
				this.style.appearance.fontStemItalic = 'normal';
			}
			this.sendmessage();
		},
		setfontStemItalicPhone() {
			if (this.stylePhone.appearancePhone.fontStemItalic == 'normal') {
				this.stylePhone.appearancePhone.fontStemItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.fontStemItalic == 'italic') {
				this.stylePhone.appearancePhone.fontStemItalic = 'normal';
			}
			this.sendmessage();
		},
		//题干 字体加粗
		setfontStemBold() {
			if (this.style.appearance.fontStemBold == 'normal') {
				this.style.appearance.fontStemBold = 'bold';
			} else if (this.style.appearance.fontStemBold == 'bold') {
				this.style.appearance.fontStemBold = 'normal';
			}
			this.sendmessage();
		},
		setfontStemBoldPhone() {
			if (this.stylePhone.appearancePhone.fontStemBold == 'normal') {
				this.stylePhone.appearancePhone.fontStemBold = 'bold';
			} else if (this.stylePhone.appearancePhone.fontStemBold == 'bold') {
				this.stylePhone.appearancePhone.fontStemBold = 'normal';
			}
			this.sendmessage();
		},
		//题干 字体颜色
		setfontStemColor(val) {
			this.style.appearance.fontStemColor = val;
			this.sendmessage();
		},
		setfontStemColorPhone(val) {
			this.stylePhone.appearancePhone.fontStemColor = val;
			this.sendmessage();
		},
		// 字体设置 题干大小
		setfontStemSize(item) {
			// console.log('itme项目题干', item);
			this.style.appearance.fontStemSize = item;
			this.sendmessage();
		},
		setfontStemSizePhone(item) {
			// console.log('itme项目题干', item);
			this.stylePhone.appearancePhone.fontStemSize = item;
			this.sendmessage();
		},
		//欢迎语 下划线
		setfontWelcomeUnderline() {
			if (this.style.appearance.fontWelcomeUnderline == 'none') {
				this.style.appearance.fontWelcomeUnderline = 'underline';
			} else if (this.style.appearance.fontWelcomeUnderline == 'underline') {
				this.style.appearance.fontWelcomeUnderline = 'none';
			}
			this.sendmessage();
		},
		setfontWelcomeUnderlinePhone() {
			if (this.stylePhone.appearancePhone.fontWelcomeUnderline == 'none') {
				this.stylePhone.appearancePhone.fontWelcomeUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.fontWelcomeUnderline == 'underline') {
				this.stylePhone.appearancePhone.fontWelcomeUnderline = 'none';
			}
			this.sendmessage();
		},
		//欢迎语 斜线
		setfontWelcomeItalic() {
			if (this.style.appearance.fontWelcomeItalic == 'normal') {
				this.style.appearance.fontWelcomeItalic = 'italic';
			} else if (this.style.appearance.fontWelcomeItalic == 'italic') {
				this.style.appearance.fontWelcomeItalic = 'normal';
			}
			this.sendmessage();
		},
		setfontWelcomeItalicPhone() {
			if (this.stylePhone.appearancePhone.fontWelcomeItalic == 'normal') {
				this.stylePhone.appearancePhone.fontWelcomeItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.fontWelcomeItalic == 'italic') {
				this.stylePhone.appearancePhone.fontWelcomeItalic = 'normal';
			}
			this.sendmessage();
		},
		//欢迎语 加粗
		setfontWelcomeBold() {
			if (this.style.appearance.fontWelcomeBold == 'normal') {
				this.style.appearance.fontWelcomeBold = 'bold';
			} else if (this.style.appearance.fontWelcomeBold == 'bold') {
				this.style.appearance.fontWelcomeBold = 'normal';
			}
			this.sendmessage();
		},
		setfontWelcomeBoldPhone() {
			if (this.stylePhone.appearancePhone.fontWelcomeBold == 'normal') {
				this.stylePhone.appearancePhone.fontWelcomeBold = 'bold';
			} else if (this.stylePhone.appearancePhone.fontWelcomeBold == 'bold') {
				this.stylePhone.appearancePhone.fontWelcomeBold = 'normal';
			}
			this.sendmessage();
		},
		//欢迎语 字体颜色
		setfontWelcomeColor(val) {
			this.style.appearance.fontWelcomeColor = val;
			this.sendmessage();
		},
		setfontWelcomeColorPhone(val) {
			this.stylePhone.appearancePhone.fontWelcomeColor = val;
			this.sendmessage();
		},
		// 字体设置 欢迎语大小
		setfontWelcomeSize(item) {
			// console.log('itme项目标题', item);
			this.style.appearance.fontWelcomeSize = item;
			this.sendmessage();
		},
		setfontWelcomeSizePhone(item) {
			// console.log('itme项目标题', item);
			this.stylePhone.appearancePhone.fontWelcomeSize = item;
			this.sendmessage();
		},
		//项目 下划线
		setfontTitleUnderline() {
			if (this.style.appearance.fontTitleUnderline == 'none') {
				this.style.appearance.fontTitleUnderline = 'underline';
			} else if (this.style.appearance.fontTitleUnderline == 'underline') {
				this.style.appearance.fontTitleUnderline = 'none';
			}
			this.sendmessage();
		},
		setfontTitleUnderlinePhone() {
			if (this.stylePhone.appearancePhone.fontTitleUnderline == 'none') {
				this.stylePhone.appearancePhone.fontTitleUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.fontTitleUnderline == 'underline') {
				this.stylePhone.appearancePhone.fontTitleUnderline = 'none';
			}
			this.sendmessage();
		},
		//项目 斜体
		setfontTitleItalic() {
			if (this.style.appearance.fontTitleItalic == 'normal') {
				this.style.appearance.fontTitleItalic = 'italic';
			} else if (this.style.appearance.fontTitleItalic == 'italic') {
				this.style.appearance.fontTitleItalic = 'normal';
			}
			this.sendmessage();
		},
		setfontTitleItalicPhone() {
			if (this.stylePhone.appearancePhone.fontTitleItalic == 'normal') {
				this.stylePhone.appearancePhone.fontTitleItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.fontTitleItalic == 'italic') {
				this.stylePhone.appearancePhone.fontTitleItalic = 'normal';
			}
			this.sendmessage();
		},
		//项目 加粗
		setfontTitleBold() {
			if (this.style.appearance.fontTitleBold == 'normal') {
				this.style.appearance.fontTitleBold = 'bold';
			} else if (this.style.appearance.fontTitleBold == 'bold') {
				this.style.appearance.fontTitleBold = 'normal';
			}
			this.sendmessage();
		},
		setfontTitleBoldPhone() {
			if (this.stylePhone.appearancePhone.fontTitleBold == 'normal') {
				this.stylePhone.appearancePhone.fontTitleBold = 'bold';
			} else if (this.stylePhone.appearancePhone.fontTitleBold == 'bold') {
				this.stylePhone.appearancePhone.fontTitleBold = 'normal';
			}
			this.sendmessage();
		},
		//项目颜色
		setfontTitleColor(val) {
			this.style.appearance.fontTitleColor = val;
			this.sendmessage();
		},
		setfontTitleColorPhone(val) {
			this.stylePhone.appearancePhone.fontTitleColor = val;
			this.sendmessage();
		},
		// 字体设置 项目标题     ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑
		setfontTitleSize(item) {
			// console.log('itme项目标题', item);
			this.style.appearance.fontTitleSize = item;
			this.sendmessage();
		},
		setfontTitleSizePhone(item) {
			// console.log('itme项目标题', item);
			this.stylePhone.appearancePhone.fontTitleSize = item;
			this.sendmessage();
		},
		// logo 位置设置
		setHTlogoLocation(item) {
			this.style.appearance.logoLocation = item;
			this.sendmessage();
		},
		setHTlogoLocationPhone(item) {
			this.stylePhone.appearancePhone.logoLocation = item;
			this.sendmessage();
		},
		// 删除logo 图片
		removelogoSet() {
			this.style.appearance.logoSet = '';
			this.sendmessage();
		},
		// 删除logo 图片
		removelogoSetPhone() {
			this.stylePhone.appearancePhone.logoSet = '';
			this.sendmessage();
		},
		//背景颜色
		setbgColor(item) {
			if (item == null) {
				item = '';
			}
			this.style.appearance.bgColor = item;
			this.sendmessage();
		},
		setbgColorPhone(item) {
			if (item == null) {
				item = '#FFFFFF';
			}
			this.stylePhone.appearancePhone.bgColor = item;
			this.sendmessage();
		},

		setbgOpacity(item) {
            console.log(item)
			this.style.appearance.bgOpacity = item;
			this.sendmessage();
		},
		setbgOpacityPhone(item) {
			this.stylePhone.appearancePhone.bgOpacity = item;
			this.sendmessage();
		},

		setbgQuestionnaire(item) {
			if (item == null) {
				item = '';
			}
			this.style.appearance.bgQuestionnaire = item;
			this.sendmessage();
		},
		setbgQuestionnairePhone(item) {
			if (item == null) {
				item = '';
			}
			this.stylePhone.appearancePhone.bgQuestionnaire = item;
			this.sendmessage();
		},
		setHTAdd(item) {
			// console.log(item);
            if ( item == 0 ) {
			    this.style.appearance.bgLocation = 'repeat'
            } else {
                this.style.appearance.bgLocation = 'no-repeat'
            }
			this.sendmessage();
		},
        setHTAddPhone(item) {
			// console.log(item);
            if ( item == 0 ) {
			    this.stylePhone.appearancePhone.bgLocation = 'repeat'
            } else {
                this.stylePhone.appearancePhone.bgLocation = 'no-repeat'
            }
			this.sendmessage();
		},
		setHTImg(item) {
			if (item == 0) {
				this.style.appearance.bgColor = ''
			} else {
				this.style.appearance.bgImg = ''
			}
			// console.log('背景图片设置', item);
			this.style.appearance.bgState = item;
			this.sendmessage();
		},
		setHTImgPhone(item) {
			if (item == 0) {
				this.stylePhone.appearancePhone.bgColor = ''
			} else {
				this.stylePhone.appearancePhone.bgImg = ''
			}
			// console.log('背景图片设置', item);
			this.stylePhone.appearancePhone.bgState = item;
			this.sendmessage();
		},
		//删除 背景图片
		removebgImg() {
			this.style.appearance.bgImg = '';
			this.sendmessage();
		},
		//删除 手机背景图片
		removebgImgPhone() {
			this.stylePhone.appearancePhone.bgImg = '';
			this.sendmessage();
		},
		removeImg() {
			this.style.appearance.headerImg = '';
			this.sendmessage();
		},
		removeImgPhone() {
			this.stylePhone.appearancePhone.headerImg = '';
			this.sendmessage();
		},
		beforeAvatarUpload(file) {
			this.QiniuData.data = file
		},
		// 上传图片成功
		handleSuccess(res) {
			// console.log('页眉图片', res);
			this.style.appearance.headerImg = res.message
			this.sendmessage();
		},
		handleSuccessPhone(res) {
			// console.log('页眉图片', res);
			this.stylePhone.appearancePhone.headerImg = res.message
			this.sendmessage();
		},
		handleRemove() {
			this.uploadPicUrl = '';
		},
		beforeAvatarUpload3(file) {
			this.QiniuData3.data = file;
		},
		handleSuccess3(res) {
			// console.log('33333333333', res);
			this.style.appearance.logoSet = res.message
			this.sendmessage();
		},
		handleSuccess3Phone(res) {
			// console.log('33333333333', res);
			this.stylePhone.appearancePhone.logoSet = res.message
			this.sendmessage();
		},
		handleRemove3() {
			this.uploadPicUrl = '';
		},
		beforeAvatarUpload2(file) {
			this.QiniuData2.data = file;
		},
		handleSuccess2(res) {
			// console.log('resqqqqqqqqqqqqq1', res);
			this.style.appearance.bgImg = res.message
			this.sendmessage();
		},
		handleSuccess2Phone(res) {
			// console.log('resqqqqqqqqqqqqq1', res);
			this.stylePhone.appearancePhone.bgImg = res.message
			this.sendmessage();
		},
		handleRemove2() {
			this.uploadPicUrl = '';
		},
		// 页眉背景颜色
		setheaderBgcolor(val) {
			this.style.appearance.headerBgcolor = val;
			this.sendmessage();
		},
		setheaderBgcolorPhone(val) {
			this.stylePhone.appearancePhone.headerBgcolor = val;
			this.sendmessage();
		},
		setheaderUnderline() {
			if (this.style.appearance.headerUnderline == 'none') {
				this.style.appearance.headerUnderline = 'underline';
			} else if (this.style.appearance.headerUnderline == 'underline') {
				this.style.appearance.headerUnderline = 'none';
			}
			this.sendmessage();
		},
		setheaderUnderlinePhone() {
			if (this.stylePhone.appearancePhone.headerUnderline == 'none') {
				this.stylePhone.appearancePhone.headerUnderline = 'underline';
			} else if (this.stylePhone.appearancePhone.headerUnderline == 'underline') {
				this.stylePhone.appearancePhone.headerUnderline = 'none';
			}
			this.sendmessage();
		},
		setheaderItalic() {
			if (this.style.appearance.headerItalic == 'normal') {
				this.style.appearance.headerItalic = 'italic';
			} else if (this.style.appearance.headerItalic == 'italic') {
				this.style.appearance.headerItalic = 'normal';
			}
			this.sendmessage();
		},
		setheaderItalicPhone() {
			if (this.stylePhone.appearancePhone.headerItalic == 'normal') {
				this.stylePhone.appearancePhone.headerItalic = 'italic';
			} else if (this.stylePhone.appearancePhone.headerItalic == 'italic') {
				this.stylePhone.appearancePhone.headerItalic = 'normal';
			}
			this.sendmessage();
		},
		// 页眉文字加粗
		setHeaderBold() {
			if (this.style.appearance.headerBold = 'normal') {
				this.style.appearance.headerBold = 'bold'
			} else if (this.style.appearance.headerBold == 'bold') {
				this.style.appearance.headerBold = 'normal'
			}
			this.sendmessage();
		},
		setHeaderBoldPhone() {
			if (this.stylePhone.appearancePhone.headerBold == 'normal') {
				this.stylePhone.appearancePhone.headerBold = 'bold';
			} else if (this.stylePhone.appearancePhone.headerBold == 'bold') {
				this.stylePhone.appearancePhone.headerBold = 'normal';
			}
			this.sendmessage();
		},
		// 页眉文字颜色
		setheaderColor(val) {
			this.style.appearance.headerColor = val;
			this.sendmessage();
			// this.$util.request(params);
		},
		setheaderColorPhone(val) {
			this.stylePhone.appearancePhone.headerColor = val;
			this.sendmessage();
			// this.$util.request(params);
		},
		// 页眉文字大小
		setTitleSize(val) {
			console.log('字体大小', val);
            
			this.style.appearance.titleSize = val;
			this.sendmessage();
		},
		setTitleSizePhone(val) {
			// console.log('字体大小', val);
			this.stylePhone.appearancePhone.headerSize = val;
			this.sendmessage();
		},
		headerAlign(item) {
			this.style.appearance.headerAlign = item;
			// console.log('输出内容', item);
			this.sendmessage();
		},
		headerAlignPhone(item) {
			this.stylePhone.appearancePhone.headerAlign = item;
			// console.log('输出内容', item);
			this.sendmessage();
		},
		setHeaderContentPhone(item) {
			this.stylePhone.appearancePhone.headerContent = item;
			this.sendmessage();
		},
		disQuest(val) {
			this.style.appearance.displayQuestionsno = val;
			this.sendmessage();
		},
		diswel(val) {
			this.style.appearance.displayWelcome = val;
			this.sendmessage();
		},
		distitle(val) {
			this.style.appearance.displayTitle = val;
			this.sendmessage();
		},
		distitlePhone(val) {
			this.stylePhone.appearancePhone.displayTitle = val;
			this.sendmessage();
		},
		disQuestPhone(val) {
			this.stylePhone.appearancePhone.displayQuestionsno = val;
			this.sendmessage();
		},
		diswelPhone(val) {
			this.stylePhone.appearancePhone.displayWelcome = val;
			this.sendmessage();
		},
		btnText() {
			//提交按钮 PC端
			this.style.appearance.buttonContent = this.buttonContentPC;
			this.sendmessage();
		},
		btnTextPhone() {
			//提交按钮手机端
			// console.log('提交按钮手机端' + val);
			this.stylePhone.appearancePhone.buttonContent = this.buttonContentTM
			this.sendmessage();
		},
		setHTPhone(val) {
			this.stylePhone.appearancePhone.headerType = val;
			this.sendmessage();
			// console.log('111', this.style.appearance.headerType);
		},
		
		setHeaderPhone(id) {
			this.stylePhone.appearancePhone.headerState = id;
			this.sendmessage();
		},

		//  默认分类
		imgSet(item) {
			// // console.log(item);
			this.style.appearance.headerState = 1;
			this.style.appearance.headerImg = item;
			this.style.appearance.bgLocation = 'repeat';
			this.style.appearance.headerType = 1;
			
			this.stylePhone.appearancePhone.headerState = 1;
			this.stylePhone.appearancePhone.headerImg = item;
			this.stylePhone.appearancePhone.bgLocation = 'repeat';
			this.stylePhone.appearancePhone.headerType = 1;

			let data = {
				surveyId: this.id,
				type: 1,
				contentjson: JSON.stringify(this.style.appearance),
				// id: this.styleId
			}
			let dataPhone = {
				surveyId: this.id,
				type: 0,
				contentjson: JSON.stringify(this.stylePhone.appearancePhone),
				// id: this.styleId
			}
			this.setStyleApi(data)
			this.setStyleApi(dataPhone)

		},
		// 主颜色下按钮颜色
		btnColor(index, item) {
			this.style.subjectColor = item.appearanceName;
			this.sendmessage();
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setsSubjectColor}`,
				method: 'POST',
				data: {
					id: that.wid,
					appearanceId: item.id
				},
				cb(res) {
					if (res.code == 0) {
						// console.log('主颜色设置成功', res);
					}
				}
			};
			this.$util.request(params);
		},
		// 主颜色下按钮颜色
		btnColorPhone(index, item) {
			this.stylePhone.subjectColor = item.appearanceName;
			this.stylePhone.appearancePhone.submitButtonColor = item.appearanceName;
			this.sendmessage();
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.setsSubjectColor}`,
				method: 'POST',
				data: {
					id: that.wid,
					appearanceId: item.id
				},
				cb(res) {
					if (res.code == 0) {
						// console.log('主颜色设置成功', res);
					}
				}
			};
			this.$util.request(params);
		},
        // 修改成功
		
		tabChange(e) {
			this.getStyleData()
			// console.log(e);
		},
		loadStyle() {
			//外观样式
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.selectAppearance}`,
				method: 'POST',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.resultBody = res.resultBody.datas;
					}
				}
			};
			this.$util.request(params);
		},
		loadAppear() {
			//外观内容
			let that = this;
			let id = that.wid;
			// console.log('输出wid', id);
			let params = {
				that: this,
				url: `${this.$config.service.selectQuestionnaire}`,
				method: 'POST',
				data: {
					id: id
				},
				cb(res) {
					if (res.code == 0) {
						that.style.appearance = res.resultBody.appearance; //pc 外观
						that.stylePhone.appearancePhone = res.resultBody.appearancePhone; //手机外观
						that.style.subjectColor = res.resultBody.subjectColor;
						that.stylePhone.subjectColor = res.resultBody.subjectColor;
						// console.log('style.app', that.style.appearance.headerState);
					}
				}
			};
			this.$util.request(params);
		}
	}
};
</script>

<style scoped>

/deep/.el-input__inner {
	width: 168px !important;
	height: 26px !important;
	border: 1px solid #ccc !important;
}
.pad {
	text-indent: 10px;
}
.mar {
	margin-left: 10px;
}
.tab_layout span {
	padding: 1px 7px;
	border: 1px solid #ccc;
}
.activeCheck {
	border: 1px solid #0080ff !important;
	color: #0080ff;
}
/deep/.el-collapse-item__content {
	padding-bottom: 0px !important;
}
.left {
	float: left;
}
.right {
	float: right;
	margin-right: 5px;
}
.heiSeting {
	width: 100%;
	height: 50px;
	line-height: 50px;
	background: #fafafa;
	border-bottom: 1px solid #e1e1e1;
}
.computer-bj {
    /* padding: 20px; */
	/* width: 820px; */
	height: auto;
    /* background-color: #fff;
    box-sizing: border-box; */
}
.setFirst {
	width: 100%;
	height: 63px;
	border-bottom: 1px solid #e1e1e1;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.wjAppearance_right_children {
	height: auto;
}
.classified_pictures {
	width: 258px;
	height: 107px;
	margin-left: 9px;
	margin-top: 17px;
}
/deep/.el-collapse-item__header {
	margin-left: 0 !important;
}
/deep/.drop-down-display .el-collapse-item__header {
	height: 68px !important;
	line-height: 68px !important;
	font-size: 16px !important;
	text-indent: 28px !important;
}
/deep/.drop-down-display .el-collapse-item__arrow.is-active {
	margin: 0 8px 28px auto;
}
/deep/.el-textarea__inner{
	-ms-overflow-style: none;
	overflow-x: hidden;
}
/deep/.el-textarea__inner::-webkit-scrollbar{
	display: none;
}

.color_btn_box {
	display: flex;
	flex-wrap: wrap;
}
.color_btn_box button {
	outline: none;
	border: none;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	margin-right: 10px;
	margin-top: 15px;
}
.phone-bj-box {
    height: 721px;
}



.phone-bj {
	width: 375px;
	/* height: 756px; */
    border-radius: 25px;
    border: 5px solid #ccc;
	/* background: url('~@/assets/examiphone.png') no-repeat center; */
	/* background-size: 100% 100%; */
	overflow: hidden;
}
/* .phone-bj-img{
	position: absolute;
	left: auto;
	top:0;
	width: 400px;
	height: 756px;
	margin-left: 200px;
    margin-right: 200px;
	background: url('~@/assets/examiphone.png') no-repeat center;
	background-size: 100% 100%;
	z-index: 998;
} */
.phoneBox {
	position: relative;
	margin-top: 15px;
	display: flex;
	justify-content: center;
}
.computerBox {
	/* width: 820px; */
	margin: 30px auto 0 auto;
}
.tab {
	padding-top: 60px;
	/* height: 200px; */
	margin: auto;
}
.wjColor_children i {
	color: #fff;
}
.wjColor_children {
	margin-left: 29px;
	padding-top: 19px;
}
.wjColor_box {
	width: 100%;
	height: 188px;
	background-color: #fff;
}
.wjAppearance_left {
	width: 360px;
	height: auto;
	position: fixed;
	top: 60px;
	left: 80px;
}
.wjAppearance_right {
	width: 360px;
	height: 100%;
	background-color: #fff;
	position: fixed;
	top: 60px;
	right: 16px;
	z-index: 999;
}
.wjAppearance_center {
	/* width: 1400px; */
	margin: auto;
	/* height: 723px; */
	justify-content: center;
	/* width: calc(100% - 736px); */
	float: left;
	display: flex;
	flex-direction: column;
}
.wjappearance {
	margin-left: 82px;
	display: flex;
	justify-content: space-between;
	margin-top: 62px;
}
.el-radio-group {
	margin: 0 auto;
}
/deep/.aaaaa .el-color-picker {
	width: 34px !important;
	height: 30px !important;
}
/deep/ .aaaaa .el-input__inner {
	width: 68px !important;
	height: 26px !important;
}
/deep/ .aaaaa .el-color-picker__color {
	border: none !important;
	background-image: url('../../../public/img/ztsz.png');
	background-repeat: no-repeat;
}
/deep/ .aaaaa .el-color-picker__trigger {
	border: none !important;
	background: transparent;
}
/deep/ .aaaaa .el-color-picker__empty {
	width: 16px;
	height: 19px;
}
/deep/ .aaaaa .el-color-picker__color-inner {
	display: none;
}
/deep/ .el-icon-close:before {
	content: none;
}
.aaaaa {
	position: absolute;
}
.imga {
	position: relative;
	top: 0;
	left: -28px;
	z-index: -99;
}

/deep/.el-drawer__wrapper,/deep/.v-modal{
    border-radius: 20px;
    width: 375px;
    top: 182px;
    left: auto;
    right: auto;
    bottom: auto;
}
/deep/.el-drawer__wrapper,/deep/.el-drawer__container,/deep/.v-modal{
    height: 721px;
}
</style>
